module.exports = __webpack_public_path__ + "img/NightCastleStableShot.02fe993f.jpg";